/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pertinent_Info_PlaceholderInputs */

const en_pertinent_info_placeholder = /** @type {(inputs: Pertinent_Info_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Important information...`)
};

const es_pertinent_info_placeholder = /** @type {(inputs: Pertinent_Info_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informacion importante...`)
};

/**
* | output |
* | --- |
* | "Important information..." |
*
* @param {Pertinent_Info_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pertinent_info_placeholder = /** @type {((inputs?: Pertinent_Info_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pertinent_Info_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pertinent_info_placeholder(inputs)
	return es_pertinent_info_placeholder(inputs)
});